import {
    BannersEditMassActions,
    SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BulkReplacementRadio } from '../../../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { TrackingParametersReplacementSelect } from '../../../components/TrackingParametersBulkReplacement/TrackingParametersBulkReplacement';
import {
    BannersEditMassActionsState,
    BannersEditMassActionState,
    MassActionId,
    protocolMenuItems,
    ProtocolValue
} from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsCalloutsReducer } from './banners-edit-mass-actions-callouts';
import { bannersEditMassActionsCountersReducer } from './banners-edit-mass-actions-counters';
import { bannersEditMassActionsCPCVideoReplaceReducer } from './banners-edit-mass-actions-cpc-video-replace';
import { bannersEditMassActionCpmImageCreativeReplaceReducer } from './banners-edit-mass-actions-cpm-image-creative';
import { bannersEditMassActionsDisplayedLinkReplaceReducer } from './banners-edit-mass-actions-displayed-link-replace';
import { bannersEditMassActionImageCreativeReplaceReducer } from './banners-edit-mass-actions-image-creative-replace';
import { bannersEditMassActionImageReplaceReducer } from './banners-edit-mass-actions-image-replace';
import { bannersEditMassActionsLinkPathReplaceReducer } from './banners-edit-mass-actions-link-path-replace';
import { bannersEditMassActionsLinkReplaceReducer } from './banners-edit-mass-actions-link-replace';
import { bannersEditMassActionsPixelReducer } from './banners-edit-mass-actions-pixel';
import { bannersEditMassActionsPriceReducer } from './banners-edit-mass-actions-prices';
import { bannersEditMassActionsSiteLinksEditorReducer } from './banners-edit-mass-actions-site-links';
import { bannersEditMassActionsTextBulkReplaceReducer } from './banners-edit-mass-actions-text-bulk';
import { bannersEditMassActionsTrackingParametersReplaceReducer } from './banners-edit-mass-actions-tracking-parameters-replace';
import { bannersEditMassActionsTurbolandingReplaceReducer } from './banners-edit-mass-actions-tublolanding-replace';
import { bannersEditMassActionsVideoReplaceReducer } from './banners-edit-mass-actions-video-replace';

export const bannersEditMassActionInitialState: BannersEditMassActionState = {
    visibleModalActions: {
        linkBulkReplacementEditorVisible: false,
        textBulkReplacementEditorVisible: false,
        linkDisplayedBulkReplacementEditorVisible: false,
        imageBulkReplacementEditorVisible: false,
        imageBulkCreativeReplacementEditorVisible: false,
        linkPathBulkReplacementEditorVisible: false,
        videoBulkReplacementEditorVisible: false,
        cpcVideoBulkReplacementEditorVisible: false,
        cpmImageCreativeBulkReplacementEditorVisible: false,
        pixelEditorVisible: false,
        countersEditorVisible: false,
        siteLinksEditorVisible: false,
        linkTrackingParametersBulkReplacementEditorVisible: false,
        calloutsEditorVisible: false,
        turbolandingBulkReplacementEditorVisible: false,
        bannerPricesEditorVisible: false
    },
    data: {
        protocols: protocolMenuItems,
        visibleItems: [],
        selectedProtocolValue: ProtocolValue.https,
        newVisibleLink: '',
        selectedLink: '',
        replaceOrDeleteToggle: BulkReplacementRadio.REPLACE,
        newText: '',
        sourceText: '',
        pixel: '',
        counters: [''],
        currentActiveRadioButtonDisplayedLinks: BulkReplacementRadio.REPLACE,
        currentCalloutsRadioState: BulkReplacementRadio.REPLACE,
        currentActiveRadioButtonVideo: BulkReplacementRadio.REPLACE,
        currentActiveRadioButtonCPCVideo: BulkReplacementRadio.REPLACE,
        selectedSourceItems: [],
        isSiteLinksTumblerChecked: true,
        isTitleTumblerChecked: true,
        isAdditionalTextTumblerChecked: true,
        currentActiveRadioButtonTubolandings: BulkReplacementRadio.REPLACE,
        currentTextBulkRadioState: BulkReplacementRadio.REPLACE,
        imageCreative: [],
        currentSiteLinksActiveRadioButton: BulkReplacementRadio.REPLACE,
        isParametersTumblerChecked: true,
        isDomainAndPathTumblerChecked: true,
        targetPartUrl: '',
        newPartUrl: '',
        targetParameters: '',
        newParameters: '',
        keyOrValueReplacement:
            TrackingParametersReplacementSelect.KEY_REPLACEMENT
    },
    errors: {
        errors: []
    },
    inProgress: false
};

export const bannersEditMassActionsInitialState = {
    [MassActionId.bannersEdit]: bannersEditMassActionInitialState,
    [MassActionId.bannerGrid]: bannersEditMassActionInitialState
};

export function bannersEditMassActions(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    state = bannersEditMassActionsLinkReplaceReducer(state, action, fullState);
    state = bannersEditMassActionsTextBulkReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsLinkPathReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsDisplayedLinkReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionImageReplaceReducer(state, action, fullState);
    state = bannersEditMassActionImageCreativeReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsVideoReplaceReducer(state, action, fullState);
    state = bannersEditMassActionsCPCVideoReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsSiteLinksEditorReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsTurbolandingReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsTrackingParametersReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsCalloutsReducer(state, action, fullState);
    state = bannersEditMassActionsPriceReducer(state, action, fullState);
    state = bannersEditMassActionCpmImageCreativeReplaceReducer(
        state,
        action,
        fullState
    );
    state = bannersEditMassActionsPixelReducer(state, action, fullState);
    state = bannersEditMassActionsCountersReducer(state, action, fullState);

    switch (action.type) {
        case SHOW_ERROR_MASS_ACTIONS_ERROR_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    inProgress: false,
                    errors: {
                        ...state[action.massActionId].errors,
                        errors: action.errors
                    }
                }
            };
        default:
            return state;
    }
}
